import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSettings } from '../../apiHelper/settingsApi'
import { SETTINGS_URL } from '../../apiHelper/apiRoute/settings'

export const getDemographics = createAsyncThunk('demographics', async () => {
  try {
    const demographics = await getSettings(SETTINGS_URL.DEMOGRAPHICS)
    return {
      ...demographics,
    }
  } catch (err) {
    console.log('Error getting demographics', err)
    return false
  }
})
